export { default as BrandIcon } from './BrandIcon';
